import React from 'react'
import { useCallback } from 'sb-hooks'
import { constants, mixpanel } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Title from 'components/_new/typography/deprecated/Title/Title'
import UpgradePlans from 'components/upgradePlans/UpgradePlans/UpgradePlans'
import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'
import { WidthContainer } from 'components/_new/layout/widthContainer'
import usePlans from 'components/upgradePlans/usePlans'

import SelectedPlanSummaryModal from '../../components/SelectedPlanSummaryModal/SelectedPlanSummaryModal'


const UpgradeSection = ({ messages, redirectLink }) => {
  const { isFetching, plans, setSelectedPlan, selectedPlan } = usePlans()

  const handlePlanSelect = useCallback(({ name, productsPerPeriod }) => {
    mixpanel.track(constants.analyticsEvents.newThankYouPage.upgradeOptionClick, {
      productsPerPeriod,
    })

    setSelectedPlan(name)
  }, [ setSelectedPlan ])

  return (
    <Box mt="36" mb="36">
      <WidthContainer>
        <Title size="sm" message={messages.title} />
        {
          Boolean(messages.description) && (
            <Text html message={messages.description} />
          )
        }
      </WidthContainer>
      <ContentWithLoader isFetching={isFetching}>
        <UpgradePlans plans={plans} onPlanSelect={handlePlanSelect} />
      </ContentWithLoader>
      {
        Boolean(selectedPlan) && (
          <SelectedPlanSummaryModal
            plan={selectedPlan}
            onClose={() => setSelectedPlan(null)}
            redirectLink={redirectLink}
          />
        )
      }
    </Box>
  )
}


export default UpgradeSection
